/**
 * Features用Swiper初期化モジュール
 *
 * SPでのみスライダーとして動作し、
 * PCでは通常のflexレイアウトになります。
 */

/**
 * Features用スライダーの初期化
 */
export function initFeaturesSwiper() {
  // Swiperが読み込まれているか確認
  if (typeof Swiper === 'undefined') {
    console.warn('Swiper is not loaded');
    return;
  }

  const featuresSwiper = document.querySelector('.js-swiper-features');
  if (!featuresSwiper) return;

  const prevBtn = document.querySelector('.js-features-prev');
  const nextBtn = document.querySelector('.js-features-next');
  const paginationEl = document.querySelector('.js-features-pagination');

  const SP_BREAKPOINT = 767;
  let swiperInstance = null;

  /**
   * Swiperを初期化
   */
  const initSwiper = () => {
    if (swiperInstance) return;

    swiperInstance = new Swiper('.js-swiper-features', {
      // loop: true,
      slidesPerView: 'auto',
      centeredSlides: true,
      spaceBetween: 20,
      speed: 500,
      navigation: {
        prevEl: prevBtn,
        nextEl: nextBtn,
      },
      pagination: {
        el: paginationEl,
        type: 'progressbar',
      },
    });
  };

  /**
   * Swiperを破棄
   */
  const destroySwiper = () => {
    if (!swiperInstance) return;

    swiperInstance.destroy(true, true);
    swiperInstance = null;
  };

  /**
   * 画面幅に応じてSwiper初期化/破棄を切り替え
   */
  const handleResize = () => {
    const isSP = window.innerWidth <= SP_BREAKPOINT;

    if (isSP) {
      initSwiper();
    } else {
      destroySwiper();
    }
  };

  // 初期実行
  handleResize();

  // リサイズ時に実行
  window.addEventListener('resize', handleResize);
}
